module.exports = __webpack_public_path__ + "static/media/im-tracker.0613f98c.png";